// export const API="https://maneemfi.com/";
export const API="https://api.maneecafe.com/";

// export const APIMERTRADE="https://api.mertrades.com/";

// export const API="http://192.168.100.5:8000";